import React, { useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { SubscriptionPriceManager } from '@/components/billing/SubscriptionPriceManager';
import { StandardPageHeader } from '@/components/layout/StandardPageHeader';
import { PageContainer } from '@/components/layout/PageContainer';
import { CreditCard, AlertCircle } from 'lucide-react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const SubscriptionManagement = () => {
  const { organizationId } = useAuth();
  const navigate = useNavigate();
  const [showTableMissingError, setShowTableMissingError] = useState(false);

  // Handle errors from the component
  const handleError = (error: any) => {
    // Check if error is a 404 (table not found)
    if (error?.code === '42P01' || error?.message?.includes('does not exist') || error?.status === 404) {
      setShowTableMissingError(true);
    }
  };

  if (!organizationId) {
    return (
      <div className="p-6">
        <p>Organization ID not found. Please make sure you're logged in with the correct account.</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <StandardPageHeader
        title="Subscription Management"
        subtitle="Create and manage subscription prices for your organization"
        icon={CreditCard}
      />
      
      <PageContainer>
      
      {showTableMissingError ? (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Database Setup Required</AlertTitle>
          <AlertDescription>
            The subscription_prices table does not exist in your database. 
            Please run the migration script to set up the required tables.
          </AlertDescription>
          <div className="mt-4">
            <Button onClick={() => navigate('/admin/settings')}>
              Go to Settings
            </Button>
          </div>
        </Alert>
      ) : (
        <SubscriptionPriceManager 
          organizationId={organizationId} 
          onError={handleError}
        />
      )}
      </PageContainer>
    </div>
  );
};

export default SubscriptionManagement; 